import {PROPERTY_SELECTOR_SIGIL} from '../constants';

/**
 * Create a function to update the existing map with a providerDetail key and its resolved value
 * Sample mapping Obj
 * mappings: {
 * 	providerComponent@providerProp: resolvedValue
 * }
 * @param resolvedMappings
 * @returns {(function(*, *): void)|*}
 */
export default function createAddResolvedPropertyMapping(resolvedMappings) {
	return function addResolvedPropertyMapping(providerDetail, resolvedValue) {
		const {providerId, providerPropName} = providerDetail;
		const providerKey = `${providerId}${PROPERTY_SELECTOR_SIGIL}${providerPropName}`;
		resolvedMappings.set(providerKey, resolvedValue);
	};
}
